import React from 'react';
import { Box } from '@mui/material';

interface SpacerProps {
  value: {
    height: string[];
  };
}

const Spacer = ({ value }: SpacerProps) => {  
  return (
    <Box      
      sx={{
        content: "''",
        height: value?.height ?? '1rem',        
        width: '100%',        
      }}
    />     
  );
};

export default Spacer;
